document.addEventListener('click', function (e) {
  const img = e.target.closest('.tee-cart-thumbnail__img');
  if (!img) return;

  e.preventDefault();
  e.stopPropagation();
}, true);

/* Club Decks: keep the card back colour in step with the card front (teeinblue).
   Hides the card back's colour list and offers two choices instead:
   "Match my card colour" or "ClubDecks Official". It selects the back colour
   by clicking teeinblue's own option, so the order records the right back. */
(function () {
  var FRONT_RE = /^card colou?r/i;
  var BACK_RE = /^cardback/i;
  var OFFICIAL_RE = /clubdecks official/i;
  var mode = null;
  var timer = null;

  function heading(field) {
    var h = field.querySelector('.tee-field__heading');
    return h ? h.textContent.replace('*', '').trim() : '';
  }
  function findField(re) {
    var fields = document.querySelectorAll('.tee-field--template');
    for (var i = 0; i < fields.length; i++) {
      if (re.test(heading(fields[i]))) return fields[i];
    }
    return null;
  }
  function labelFor(input) {
    return document.querySelector('label[for="' + input.id + '"]');
  }
  function optName(input) {
    var l = labelFor(input);
    if (!l) return '';
    return (l.getAttribute('data-title') || l.textContent || '').trim();
  }
  function activeInput(field) {
    return field.querySelector('.tee-field__input .active input[type="radio"]');
  }
  function activeName(field) {
    var a = activeInput(field);
    return a ? optName(a) : '';
  }
  function pick(field, test) {
    var inputs = field.querySelectorAll('.tee-field__input input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (test(optName(inputs[i]))) {
        if (activeInput(field) === inputs[i]) return;
        var l = labelFor(inputs[i]);
        if (l) l.click();
        return;
      }
    }
  }

  function addStyles() {
    if (document.getElementById('cd-back-sync-style')) return;
    var s = document.createElement('style');
    s.id = 'cd-back-sync-style';
    s.textContent =
      '.cd-back-sync > .tee-field__input{display:none!important}' +
      '.cd-mirrored{display:none!important}' +
      '.cd-back-choice{display:flex;flex-wrap:wrap;gap:8px;margin:8px 0 4px}' +
      '.cd-back-choice input{position:absolute;opacity:0;width:1px;height:1px}' +
      '.cd-back-choice label{display:inline-flex;align-items:center;min-height:44px;padding:0 16px;border:1px solid rgba(0,0,0,.25);border-radius:999px;cursor:pointer;font-size:15px;background:#fff}' +
      '.cd-back-choice input:checked + label{border:2px solid #00447D;background:#F2F7FC;font-weight:700}' +
      '.cd-back-choice input:focus-visible + label{outline:3px solid #2E7BD6;outline-offset:2px}' +
      '.cd-back-hint{font-size:13px;opacity:.75;margin:0 0 4px}';
    document.head.appendChild(s);
  }

  function ensureUI(back) {
    if (back.querySelector('.cd-back-choice')) return;
    addStyles();
    if (mode === null) mode = OFFICIAL_RE.test(activeName(back)) || !activeName(back) ? 'official' : 'match';
    back.classList.add('cd-back-sync');
    var wrap = document.createElement('div');
    wrap.className = 'cd-back-choice';
    wrap.setAttribute('role', 'radiogroup');
    wrap.setAttribute('aria-label', 'Card back');
    [['official', 'ClubDecks Official'], ['match', 'Match my card colour']].forEach(function (o) {
      var id = 'cd-back-' + o[0];
      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'cd-back-choice';
      input.id = id;
      input.value = o[0];
      input.checked = mode === o[0];
      input.addEventListener('change', function () {
        mode = o[0];
        sync();
      });
      var label = document.createElement('label');
      label.setAttribute('for', id);
      label.textContent = o[1];
      wrap.appendChild(input);
      wrap.appendChild(label);
    });
    var hint = document.createElement('p');
    hint.className = 'cd-back-hint';
    hint.textContent = 'Matching the card colour adds player details to the back.';
    var input = back.querySelector('.tee-field__input');
    back.insertBefore(wrap, input);
    back.insertBefore(hint, input);
  }

  /* The back has its own Player Name and Team Name fields. Copy the front's
     answers into them and hide them, so customers only type each once. */
  var MIRROR = [/^player name$/i, /^team name$/i];
  var setValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  function textInput(field) {
    return field.querySelector('.tee-field__input input[type="text"]');
  }
  function mirror(back) {
    var all = Array.prototype.slice.call(document.querySelectorAll('.tee-field'));
    var at = all.indexOf(back);
    var before = all.slice(0, at);
    var after = all.slice(at + 1);
    MIRROR.forEach(function (re) {
      var f = null, b = null, i;
      for (i = 0; i < before.length; i++) { if (re.test(heading(before[i]))) { f = before[i]; break; } }
      for (i = 0; i < after.length; i++) { if (re.test(heading(after[i]))) { b = after[i]; break; } }
      if (!f || !b) return;
      var fi = textInput(f), bi = textInput(b);
      if (!fi || !bi) return;
      b.classList.add('cd-mirrored');
      if (!fi.getAttribute('data-cd-mirror')) {
        fi.setAttribute('data-cd-mirror', '1');
        fi.addEventListener('input', schedule);
      }
      if (bi.value !== fi.value) {
        setValue.call(bi, fi.value);
        bi.dispatchEvent(new Event('input', { bubbles: true }));
        bi.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function sync() {
    var front = findField(FRONT_RE);
    var back = findField(BACK_RE);
    if (!front || !back) return;
    ensureUI(back);
    if (mode === 'match') {
      var name = activeName(front).toLowerCase();
      if (name) pick(back, function (n) { return n.toLowerCase() === name; });
      mirror(back);
    } else {
      pick(back, function (n) { return OFFICIAL_RE.test(n); });
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 120);
  }

  function start() {
    schedule();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
